module.exports = __webpack_public_path__ + "media/images/icons/ios-icon-957d4d568e1ba0a7e3588649952eaab2.svg";